import WorkOrder from "./workOrder";

const getWorOrderDisplayName = (workOrder: WorkOrder | undefined) => {
  if (!workOrder) {
    return "";
  }

  return `${workOrder.entityName} # ${workOrder.workOrderNumber}`;
};

const workOrderHelper = {
  getWorOrderDisplayName,
};

export default workOrderHelper;
